import axios from 'axios';
import router from './routers';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

apiClient.interceptors.response.use(
    response => response, 
    error => {
        
        if (error.response && error.response.status === 503) {

            localStorage.removeItem('token');
            localStorage.removeItem('user');
            router.push('/');
        }

        return Promise.reject(error);
    }
);

const getAuthToken = () => localStorage.getItem('token');

export const apiRequest = async (endpoint, method = 'GET', data = null, customHeaders = {}) => {

    try{
        const token = getAuthToken();
        const headers = {
            Authorization : `Bearer ${token}`,
            ...customHeaders
        }

        const config = {
            method,
            url : endpoint,
            headers,
            ...(data ? { data } : {})
        };

        const response = await apiClient(config);
        return response;

    }catch(error){
        console.error("API Error:", error.response?.data || error.message);
        throw error;
    }

};

export default apiClient;